import bnafar from './bnafar'
import ria from './ria'
import erpsaude from './erpsaude'

export default baseUrl => {
    baseUrl = `${baseUrl}/integracao`

    return {
        bnafar: bnafar(baseUrl),
        ria: ria(baseUrl),
        erpsaude: erpsaude(baseUrl),
    }
}